export const SET_CURRENT_AND_PREVIOUS_ROUTE = "SET_CURRENT_AND_PREVIOUS_ROUTE";

export interface SetCurrentandPreviousRoute {
    type: typeof SET_CURRENT_AND_PREVIOUS_ROUTE;
    payload: { data: string };
}

export interface RouterStateInterface {
    routeDetails: {
        prev: string;
        current: string;
    };
}

export type RouterTypes = SetCurrentandPreviousRoute;
